import React from "react"
import { useLanguage } from "../../../context/LanguageContext"

const RecentCard = () => {
  const { content } = useLanguage()
  const { recent } = content.home

  return (
    <>
      <div className='content grid3 mtop'>
        {recent.items.map((item) => {
          const { id, cover, categoryKey, categoryLabel, location, name, price, type } = item
          return (
            <div className='box shadow' key={id}>
              <div className='img'>
                <img src={cover} alt={name} />
              </div>
              <div className='text'>
                <div className='category flex'>
                  <span style={{ background: categoryKey === "sale" ? "#25b5791a" : "#ff98001a", color: categoryKey === "sale" ? "#25b579" : "#ff9800" }}>{categoryLabel}</span>
                  <i className='fa fa-heart'></i>
                </div>
                <h4>{name}</h4>
                <p>
                  <i className='fa fa-location-dot'></i> {location}
                </p>
              </div>
              <div className='button flex'>
                <div>
                  <button type='button' className='btn2'>
                    {price}
                  </button>{" "}
                  <span>{recent.areaUnit}</span>
                </div>
                <span>{type}</span>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default RecentCard
